// extracted by mini-css-extract-plugin
module.exports = {"loading":"style_loading__w1YfU","loadingPage":"style_loadingPage__2BuKE"};